import { createContext } from "react";
const ProjectContext = createContext(null);
const ActivityContext = createContext(null);
const ProductContext = createContext(null);
const UserProjectContext = createContext(null);
const DiffusionContext = createContext(null);
const DescriptionContext = createContext(null)
export { ProjectContext, ActivityContext, ProductContext, UserProjectContext,DiffusionContext,DescriptionContext };
